export const defaultInputs = {
    personal_info: {
      first_name: "",
      last_name: " ",
      email: "",
      mobile: "",
      address: "",
      city: "",
      state: "",
      pin_code: "",
      objective:"",
    },
    work_experience: [
      {
        id: 1,
        job_title: "",
        organization_name: "",
        start_year: "",
        end_year: "",
      },
      {
        id: 2,
        job_title: "",
        organization_name: "",
        start_year: "",
        end_year: "",
      },
    ],
    education_details: {
      type: "",
      university: " ",
      degree: "",
      start_year: "",
      end_year: "",
    },
    key_skills: ["", "", "", ""],
    achievements: ["", "", "", ""],
    projects: ["", "", "", ""],
  };
  